import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function Gallery() {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await fetch("https://cauverytours.in/cauverytours-backend/admin/gallery.php");
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log("API Response:", data);
        
        if (Array.isArray(data)) {
          // CORRECT THE IMAGE PATHS
          const correctedGallery = data.map(item => {
            // Extract filename from the current image URL
            const filename = item.image.split('/').pop();
            // Build correct path with uploads/gallery
            const correctImagePath = `https://cauverytours.in/cauverytours-backend/uploads/gallery/${filename}`;
            
            return {
              ...item,
              image: correctImagePath
            };
          });
          
          setGallery(correctedGallery);
          console.log("Corrected gallery data:", correctedGallery);
        } else {
          setError("Invalid response format from server.");
        }
      } catch (err) {
        console.error("Gallery fetch error:", err);
        setError("An error occurred while fetching gallery: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []);

  const handleImageError = (e, item) => {
    console.error(`Failed to load image: ${item.image}`);
    e.target.src = "https://via.placeholder.com/300x200/4A90E2/FFFFFF?text=Image+Loading...";
    e.target.alt = `Failed to load: ${item.title}`;
  };

  const handleImageLoad = (e, item) => {
    console.log(`Successfully loaded image: ${item.image}`);
  };

  if (loading) return (
    <div className="gallery-container" id="services">
      <div style={{ textAlign: "center", padding: "50px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading gallery...</p>
      </div>
    </div>
  );

  if (error) return (
    <div className="gallery-container" id="services">
      <div style={{ textAlign: "center", padding: "50px", color: "red" }}>
        <i className="fas fa-exclamation-triangle fa-2x mb-3"></i>
        <p>{error}</p>
      </div>
    </div>
  );

  if (gallery.length === 0) return (
    <div className="gallery-container" id="services">
      <div style={{ textAlign: "center", padding: "50px" }}>
        <i className="fas fa-images fa-2x mb-3 text-muted"></i>
        <p>No gallery images found.</p>
      </div>
    </div>
  );

  return (
    <section className="gallery-container py-5" id="services" style={{ background: "linear-gradient(135deg, #284f9e 0%, #284f9e 100%)" }}>
      <div className="container">
        <h2 className="text-center text-white mb-5" style={{ 
          fontSize: "2.5rem",
          fontWeight: "700",
          textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
          marginBottom: "80px",
          textDecoration: "underline",
          textUnderlineOffset: "10px"
        }}>
          Our Tour Packages
        </h2>
        
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={4}
          spaceBetween={20}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          loop={true}
          pagination={{ 
            clickable: true,
            dynamicBullets: true
          }}
          breakpoints={{
            320: { 
              slidesPerView: 1,
              spaceBetween: 10
            },
            640: { 
              slidesPerView: 2,
              spaceBetween: 15
            },
            992: { 
              slidesPerView: 3,
              spaceBetween: 20
            },
            1200: { 
              slidesPerView: 4,
              spaceBetween: 20
            }
          }}
          style={{ padding: "20px 0" }}
        >
          {gallery.map(item => (
            <SwiperSlide key={item.id}>
              <div className="gallery-item text-center" style={{ padding: "10px" }}>
                <div className="card border-0 shadow-lg" style={{ 
                  borderRadius: "15px",
                  overflow: "hidden",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  background: "rgba(255,255,255,0.95)"
                }}>
                  <div style={{ 
                    width: "100%", 
                    height: "250px", 
                    overflow: "hidden",
                    position: "relative"
                  }}>
                    <img
                      src={item.image}
                      alt={item.title || "Tour package"}
                      onError={(e) => handleImageError(e, item)}
                      onLoad={(e) => handleImageLoad(e, item)}
                      style={{ 
                        width: "100%", 
                        height: "100%", 
                        objectFit: "cover",
                        transition: "transform 0.5s ease"
                      }}
                      className="hover-zoom"
                    />
                    <div className="card-overlay" style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "linear-gradient(to bottom, transparent 60%, rgba(0,0,0,0.7))",
                      opacity: 0,
                      transition: "opacity 0.3s ease"
                    }}></div>
                  </div>
                  
                  <div className="card-body" style={{ padding: "20px 15px" }}>
                    {item.title && (
                      <h5 className="card-title" style={{ 
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                        color: "#333",
                        marginBottom: "5px"
                      }}>
                        {item.title}
                      </h5>
                    )}
                    {item.subtitle && item.subtitle !== " Cauvery Tours" && (
                      <p className="card-text" style={{ 
                        fontSize: "0.9rem",
                        color: "#666",
                        marginBottom: "0"
                      }}>
                        {item.subtitle}
                      </p>
                    )}
                    {item.link && (
                      <a 
                        href={item.link} 
                        className="btn btn-primary btn-sm mt-3"
                        style={{
                          borderRadius: "20px",
                          padding: "5px 15px",
                          fontSize: "0.8rem"
                        }}
                      >
                        Learn More
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Add some custom CSS for hover effects */}
        <style jsx>{`
          .hover-zoom:hover {
            transform: scale(1.05);
          }
          .gallery-item:hover .card {
            transform: translateY(-10px);
            box-shadow: 0 15px 30px rgba(0,0,0,0.2) !important;
          }
          .gallery-item:hover .card-overlay {
            opacity: 1;
          }
        `}</style>
      </div>
    </section>
  );
}